export const setCart = (items) => ({
  type: "SET_CART",
  payload: items,
});
